﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

import * as api from "~base/Services/API";
import * as accountModel from "./Model";

//-------------------------------------------------------------------------------------
// Constants
//-------------------------------------------------------------------------------------

const uri = "api/account/v1/users/reset-password";
const method = "POST";

//-------------------------------------------------------------------------------------
// Types
//-------------------------------------------------------------------------------------

interface PostResetPasswordProps extends api.ApiHookBaseProps<
    accountModel.PostResetPasswordRequest,
    unknown,
    unknown
> {}

//-------------------------------------------------------------------------------------
// API Hook
//-------------------------------------------------------------------------------------

export function useAccountPostResetPassword(
    params: PostResetPasswordProps
): [
    boolean,
    (data: accountModel.PostResetPasswordRequest) => Promise<unknown>,
] {
    const apiParams: api.ApiHookProps<
        accountModel.PostResetPasswordRequest,
        unknown,
        unknown
    > = {
        ...params,
        uri: uri,
        method: method,
        skipResponseParsing: true,
        anonymous: true,
    };

    const [loading, invoker] = api.useApi<
        accountModel.PostResetPasswordRequest,
        unknown,
        unknown
    >(apiParams);
    return [loading, (data) => invoker(apiParams.uri, data)];
}
